import React from 'react';
import {
	AcademicPartnerContentItemCategory,
	GetMemberProgramQuery,
} from 'src/graphqlTypes/catalogServiceTypes';
import { Accordion, TextLink, Typography } from '@guildeducationinc/recess';
import { BENEFITS_SPONSORSHIP_URL } from 'src/utilities/envConfig';
import { trackEvent } from 'src/services/analytics';
import { isAffiliateProgram } from '@src/utilities/offeringHitsUtility';
import styles from './ApplicationSteps.module.scss';

interface Props {
	program: GetMemberProgramQuery['memberProgram'];
}

export const ApplicationSteps: React.FC<Props> = ({ program }) => {
	const steps = program?.studentFacingAcademicPartner.contentItems.filter(
		item => item.category === AcademicPartnerContentItemCategory.APPLICATION_STEP
	);

	if (!steps.length) {
		return null;
	}

	const stepsTitle = ({ isOpen }) => {
		if (isOpen) {
			trackEvent('Clickable', {
				tag: 'applications_section',
				text: 'application_steps',
				type: 'accordion',
			});
		}
		return <Typography variant='title3'>Application steps</Typography>;
	};

	return (
		<Accordion title={stepsTitle}>
			<div>
				<Typography data-testid='steps-subhead' variant='body1' weight='bold'>
					Here is a general outline of what to expect:
				</Typography>
				<ol className={styles.stepsList}>
					{steps.map(({ body }) => (
						<li data-testid='steps-item' key={body}>
							<Typography variant='body1'>{body}</Typography>
						</li>
					))}
				</ol>
				{isAffiliateProgram(program) && (
					<TextLink
						href={BENEFITS_SPONSORSHIP_URL}
						newWindowIcon={true}
						newWindowNotification={true}
						target='_blank'
					>
						Learn more about the Direct Payment Program
					</TextLink>
				)}
			</div>
		</Accordion>
	);
};
